{
  "page_count": "/ {n, plural, one{# sayfa} other{# sayfa}}"
}
